<template>
  <div class="archive">
    <div class="container">
      <div class="">
        <div class="col content">
          <h1>Day {{ $route.params.dayNum }} Archives</h1>
          <div id="videoPlaceholder" class="video-iframe slide" v-on:mouseover="loadIframe(events($route.params.dayNum))" >
            <h1>If video fails to load, move your mouse here.</h1>
          </div>
        </div>
      </div>
      <div class="">
        <div class="col content">
          <div class="schedule-col-contents">
            <h2 class="schedule-col-header">Day {{ $route.params.dayNum }}</h2>
            <div v-for="p in presentations($route.params.dayNum)" :key="p.title">
              <div v-if="!p.bonus" class="schedule-col-section">
                <h3 class="presentation-speaker">{{ speakerNames(p.speakers) }}</h3>
                <p class="presentation-time">{{ p.start_time }} - {{ p.end_time }}</p>
                <p class="presentation-link">
                  <a v-if="p.video_id" v-bind:href="presentationLink(p, $route.params.dayNum)" v-on:click="loadIframe(p)" v-bind:id="presentationHash(p)">
                    <span :id="p.video_id" v-html="p.title"></span>
                  </a>
                  <span v-if="!p.video_id" v-html="p.title"></span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from '../db';
import auth from '../auth';
import helpers from '../helpers';

export default {
  name: 'Archive',
  firebase: helpers.getFirebaseObject(db),
  data() {
    return {
      year: helpers.getYear(),
      presentationId: this.$route.params.presentationHash,
    }
  },
  beforeMount() { auth.requireLogin(); },
  mounted() {
    if (this.presentationId) {
      let el = document.getElementById(this.presentationId);
      if (el != null) {
        el.scrollIntoView();
        el.click();
      }
    }
  },
  beforeUpdate() {
    if(this.days && this.days.length > 0) {
      this.loadIframe(this.events(this.dayNum))
    }
  },
  computed: {
    dayNum() {
      return this.$route.params.dayNum;
    }
  },
  watch: {
    dayNum: function () {
      location.reload();
    },
  },
  methods: {
    events(dayNum) {
      const event_id = helpers.getEventsByDay(this.days, dayNum);
      return event_id;
    },
    presentations(dayNum) {
      let presentations = helpers.getPresentationsByDay(this.speakers, this.options);
      return presentations[parseInt(dayNum) - 1];
    },
    itemHeading(presentation) {
      let speaker = presentation.speakers[0];
      if (presentation.speakers.length > 1) {
        speaker = 'Panel Discussion';
      }
      return speaker + ' | ' + presentation.title;
    },
    speakerNames(speakers) {
      if (!speakers) return;
      let rtn = '';

      speakers.forEach((speaker, i) => {
        if (speakers.length > 1 && i === speakers.length - 1) {
          rtn += 'and ';
        }
        rtn += speaker;
        if (i !== speakers.length - 1) {
          rtn += ', ';
        }
      });
      return rtn;
    },
    presentationLink(presentation, dayNum) {
      let hashCode = helpers.getPresentationHash(presentation);
      return '/#/archive/'+dayNum+'/'+hashCode;
    },
    presentationHash(presentation) {
      return helpers.getPresentationHash(presentation);
    },
    presentationHasEnded(presentation) {
      let p = presentation;
      let offset = helpers.getUTCOffset(this.options);
      let endTime = helpers.getTimestamp(p.date, p.end_time, offset);

      if (endTime < helpers.now()) {
        return true;
      }
      return false;
    },
    scrollToPresentation(presentation) {
      let hash = helpers.getPresentationHash(presentation);
      let el = document.getElementById(hash);
      el.scrollIntoView();
    },
    loadIframe(presentation) {
      let iframe = document.createElement('iframe');
      let videoPlaceHolder = document.getElementById("videoPlaceholder");

      iframe.setAttribute('width', '1200');
      iframe.setAttribute('height', '675');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('mozallowfullscreen', '');
      iframe.setAttribute('webkitallowfullscreen', '');
      iframe.setAttribute('oallowfullscreen', '');
      iframe.setAttribute('msallowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('scrolling', 'no');
      iframe.setAttribute('style', 'max-width: 100%;');

      if (presentation.video_host === 'wistia') {
        iframe.src = `https://fast.wistia.net/embed/iframe/${presentation.video_id}?videoFoam=true`;

        iframe.setAttribute('allowtransparency', 'true');
        iframe.setAttribute('name', 'wistia_embed');

      } else { // it's a livestream.com video
        let accountId = this.options.live_accountid;
        let eventId = this.events(this.$route.params.dayNum)
        iframe.src = `https://livestream.com/accounts/${accountId}/events/${eventId}`;
        if (presentation.video_host !== undefined) {
          iframe.src += `/videos/${presentation.video_id}`;
          videoPlaceHolder = document.getElementById(presentation.video_id);
        }
        iframe.src += '/player?width=1200&height=675&enableInfo=false&defaultDrawer=&autoPlay=false&mute=false';
      }

      videoPlaceHolder.replaceWith(iframe);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slide {
  max-width: 1200px;
  height: 675px;
  min-height: 474px;
  text-align: center;
  padding: 25% 5%;
  color: #fdfdfd;
  font-weight: bold;
  margin-bottom: 5px;
  background-color: #0B202B;
border-top: 10px solid #6DC5CB;

}

.slide > h1 {
  font-size: 2.6em;
  border: 1px solid #fdfdfd;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Archive.vue